module.exports = __webpack_public_path__ + "img/bg_video.0d794552.jpg";